import React, { Component } from 'react';
import FAQCategory from '../../../../src/models/FAQCategory';
import FAQSubCategory from '../../../../src/models/FAQSubCategory';
import FAQSubCategoryView from './FAQSubCategoryView';

type FAQCategoryViewProps = {
    category: FAQCategory,
}

export default class FAQCategoryView extends Component<FAQCategoryViewProps, any> {
    public render() {
        const subcategoriesWithArticles: FAQSubCategory[] = this.props.category.subCategories.filter((subCategory: FAQSubCategory) => { return subCategory.articles.length > 0; });

        return (
            <div>
                <h2 className="h4 mb-4">{this.props.category.title}</h2>
                <h3 className='sr-only' aria-live='polite'>{subcategoriesWithArticles.length} categories found</h3>
                {
                    subcategoriesWithArticles.length > 0 ?
                        subcategoriesWithArticles.map((subCategory: FAQSubCategory, index: number) => {
                            return (
                                <FAQSubCategoryView subCategory={subCategory} showTitle={subcategoriesWithArticles.length > 1} key={"subCategory_" + index}></FAQSubCategoryView>
                            )
                        })
                        :
                        <div>
                            There are no questions for this category
                        </div>
                }
            </div>
        );
    }
}